import {
  GroupedPriceBreakdown,
  VatBreakdown,
  VatBreakdownConfig,
  ProportionalVatBreakdown
} from './price-breakdown-types'
import { round } from '../common/prices'

import { Offer } from '../../types/types'
import { vatPriceBreakdownCalulator } from './vat-utils'

export function applyVat(
  vatBreakdownConfig: VatBreakdownConfig[],
  groupedPriceBreakdown: GroupedPriceBreakdown,
  offer?: Offer
): GroupedPriceBreakdown {
  const isEscalationFlow = offer && offer.isEscalationFlow
  const withoutVat =
    isEscalationFlow && isEscalationFlow.active
      ? isEscalationFlow.escalatedAnnualPrice
      : groupedPriceBreakdown.annualSalesPrice

  const vatPriceBreakdown: VatBreakdown[] = vatPriceBreakdownCalulator(vatBreakdownConfig, withoutVat)

  const annualVatPrice = vatPriceBreakdown.reduce((acc, vpb) => acc + vpb.annualVatPrice, 0)

  const annualListPriceWithVat = round(groupedPriceBreakdown.annualListPrice + annualVatPrice)
  const annualSalesPriceWithVat = round(groupedPriceBreakdown.annualSalesPrice + annualVatPrice)
  return {
    ...groupedPriceBreakdown,
    annualVatPrice,
    annualListPriceWithVat,
    annualSalesPriceWithVat,
    vatPriceBreakdown
  }
}

export function applyVatOnPrice(price: number, vatBreakdown: VatBreakdown[]): ProportionalVatBreakdown {
  const vatPriceBreakdown: VatBreakdown[] = vatBreakdown.map(vpc => ({
    key: vpc.key,
    vatStr: vpc.vatStr,
    vatPercentage: vpc.vatPercentage,
    annualVatPrice: round(price * ((100 + vpc.vatPercentage) / 100) - price)
  }))
  const vatPrice = vatPriceBreakdown.reduce((acc, vpb) => acc + (vpb.annualVatPrice || 0), 0)
  const priceWithVat = round(price + vatPrice)
  return {
    vatPriceBreakdown,
    vatPrice,
    priceWithVat,
    priceWithoutVat: price
  }
}
